import React, { Component } from "react";

import { CModal, CModalBody, CModalHeader, CModalTitle } from "@coreui/react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";

import "react-bootstrap-table/dist//react-bootstrap-table-all.min.css";

class SelectUserModalModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      users: []
      // activities: [],
      // docs: [],
      // selected: null,
      // doc_id: null,
      // type: "activity"
    };

    this.selectRowProp = {
      mode: "radio",
      bgColor: "#3399ff22", // you should give a bgcolor, otherwise, you can't regonize which row has been selected
      hideSelectColumn: true, // enable hide selection column.
      clickToSelect: true // you should enable clickToSelect, otherwise, you can't select column.
    };

    this.options = {
      onRowClick: row => this.onRowClick(row)
    };
  }

  onRowClick(row) {
    this.props.onClose(row);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    this.handleUsers();
  }

  handleUsers() {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ loading: true, selected: null });

    axios
      .get(`${URL.api}activity/execution/item/listUsers`, {
        params: {
          allocation_id: this.props.allocation_id,
          item_id: this.props.item_id
        },
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({ users: resp.data.data, loading: false });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  render() {
    return (
      <CModal size="lg" show onClose={() => this.props.onClose()} centered>
        <CModalHeader closeButton>
          <CModalTitle className="d-inline-block mr-1">
            Selecionar usuário
          </CModalTitle>
        </CModalHeader>
        <CModalBody
          className="p-0"
          style={{ maxHeight: "60vh", overflow: "auto" }}
        >
          {this.state.loading ? (
            <div className="d-flex p-4 justify-content-center">
              <Loading />
            </div>
          ) : this.state.users.length > 0 ? (
            <BootstrapTable
              data={this.state.users}
              selectRow={this.selectRowProp}
              options={this.options}
              tableStyle={{ border: 0 }}
              trClassName="cursor"
              hover
              version="4"
            >
              <TableHeaderColumn
                className="d-none"
                tdStyle={{
                  border: 0,
                  padding: "1.25rem",
                  display: "flex",
                  alignItems: "center"
                }}
                isKey
                dataField="id"
                dataFormat={(_, row) => (
                  <div className="d-flex align-items-center">
                    <img
                      className="c-avatar-img mr-3"
                      style={{ width: "100%", maxHeight: "2rem" }}
                      src={
                        row.user_photo
                          ? URL.img + row.user_photo
                          : `${URL.img}uploads/users/profileEmpty.jpg`
                      }
                      alt=""
                    />
                    {row.user_name}
                  </div>
                )}
              >
                Nome
              </TableHeaderColumn>
              <TableHeaderColumn
                className="d-none"
                tdStyle={{
                  border: 0,
                  padding: "1.25rem",
                  verticalAlign: "middle"
                }}
                dataField="final_grade"
                dataFormat={(_, row) => (
                  <>
                    {row.final_grade ? (
                      <div className="d-flex align-items-center text-primary">
                        Nota: {row.final_grade}
                      </div>
                    ) : (
                      <div className="d-flex align-items-center text-danger">
                        Não corrigido
                      </div>
                    )}
                  </>
                )}
              >
                Nota
              </TableHeaderColumn>
            </BootstrapTable>
          ) : (
            <div className="d-flex p-5 justify-content-center">
              <span className="text-center text-muted">
                Nenhum usuário realizou esta atividade ainda
              </span>
            </div>
          )}
        </CModalBody>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectUserModalModal);
